import { Edit, Remove } from "@app/components/Actions";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import pathRoutes from "../../../routes/pathRoutes";
import { useTransitDose } from "./useTransitDose";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsTransitDoses: GridColDef[] = [
  {
    field: "id",
    headerName: "ID",
    headerAlign: "center",
  },
  {
    field: "registration_date",
    headerName: "Fecha de registro",
    headerAlign: "center",
    flex: 1,
    renderCell: (params) => (
      <div className="flexCenter">
        {dayjs(params.row.registration_date).format("DD/MM/YYYY")}
      </div>
    ),
  },
  {
    field: "instalation.id",
    headerName: "Instalación",
    headerAlign: "center",
    flex: 1,
    renderCell: (params) => (
      <div className="flexCenter">
        {params.row.instalation.codigo}-{params.row.instalation.descripcion}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit to={`${pathRoutes.ADMIN_TRANSIT}/editar/${params.id}`} />
          <Remove
            onRemove={() => useTransitDose.getState().delete(params.id)}
            title="Va a borrar de forma permanente esta dosis de tránsito"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
